import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { 
    Col, 
    Row,
    CardText,
    Card,
    CardBody
} from 'reactstrap';

import DateToHuman from '../../components/DateToHuman';
import Paginations from '../../components/Paginations';
import PaginationSummaries from '../../components/Paginations/PaginationSummaries';
import { Tbl, TblHead, TblBody, Th } from '../../components/Tbl';
import FilterPanel from './Filters';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars';
import CheckReadOnly from '../../components/CheckReadOnly';
import privateView from '../../components/hocs/privateView';

import { generateNumber } from '../../utils';
import { DEFAULT_PER_PAGE } from '../../constants/settings';
import { getCollectionList } from '../../actions/collectionAction';
import CollectionTypeButton from './Filters/CollectionTypeButton';
import { TitleColumn } from './collectionIndex/Columns';
import Analytics from "../../services/Analytics";

const defaultParams = {
  sort_by : 'createdAt_desc',
  per_page : DEFAULT_PER_PAGE
}

class CollectionIndex extends Component{
  constructor(){
    super();
    this.state={
      _params:{
        ...defaultParams
      },
      _filterOpen: false
    }
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    this._getList(this.state._params);
    Analytics.recordPageView('collection_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _toggleFilterPanel(){
    this.setState({_filterOpen:!this.state._filterOpen})
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

    /**
 * Function to handle rendering table's items or rows
 * @author pewe
 */
  _onRenderRowItem(){
    if(this.props.masterCollection.list.status_code===200 && this.props.masterCollection.list.data.length>0)
		{
			const { current_page,per_page } =  this.props.masterCollection.list;
			return this.props.masterCollection.list.data.map((item,idx)=>
				(
					<tr key={parseInt((per_page*(current_page-1))+idx+1)}>
						<th className="v-center" scope="row">{ parseInt((per_page*(current_page-1))+idx+1) }</th>
            <td className="v-center">
              <TitleColumn
                id={item.id}
                categories={item.categories}
                slug={item.slug}
                name={item.name}
                parentId={item.parent_id}
                parent={item.parent}
                uiTemplate={item.ui_template}
                peoples={item.peoples}
                createdAt={item.created_at}
                collectionType={item.collection_type}
                itemCount={item.ui_template === "PARENT"? item.children_count : item.collection_type==='product_variants'? item.collection_variants_count:(item.collection_type==='brands'? item.collection_brands_count:0)}
              />
            </td>
            <td className="v-center">
              <CheckReadOnly check={item.active}/>
            </td>
            <td className="v-center">
              <CheckReadOnly check={item.featured}/>
            </td>
            <td className="v-center">
              {
                item.order?(
                  <div className="mb-2" style={{fontSize: ".65rem"}}>
                    CUSTOM ORDER: {item.order}
                  </div>
                ):null
              }
              <DateToHuman  value={item.updated_at} id={`tooltip_updated_at_${generateNumber(per_page,current_page,idx)}`}/>
            </td>
            <td className="v-center">
              {item.parent_id? (
                <div className="mb-2">
                  <Link to={`/collections/${item.parent_id}`} className="text-success btn btn-link">Parent Details</Link>
                </div>
              ) :null}
							<Link to={`/collections/${item.id}`} className="btn btn-link">Details</Link>
						</td>
					</tr>
				)
			)	
		}
		return null;
  }

  /**
  * Function to handle rendering paginations
  * @author pewe
  */
	_onRenderPagination(){
    const {status_code, data} = this.props.masterCollection.list;
    const hasData = (status_code===200 && data.length)||null;
    return hasData && (
      <Paginations 
        size="sm" 
        lastPage={this.props.masterCollection.list.last_page} 
        perPage={this.props.masterCollection.list.per_page}
        total={this.props.masterCollection.list.total}
        maxPage={8}
        path={this.props.masterCollection.list.path}
        currentPage={this.props.masterCollection.list.current_page} 
        prevPageUrl={this.props.masterCollection.list.prev_page_url} 
        nextPageUrl={this.props.masterCollection.list.next_page_url} 
        handleGotoCallback={this._handleGoto}
      />
    )
  }

	/**
	 * Handle callback when user click pagination items
	 * @author pewe
	 * @param {integer} page 
	 */
	_handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList({params});
  }

  _handleParamsChange(e){
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleParamsChangeAndSubmit(e){
    // Exclude page...
    const { page , ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    this.setState({_params},()=>{
      this._getList(this.state._params);
    });    
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _refreshList(){
    const {page, ..._params} = this.state._params;
    this.setState({
      _params
    },()=>this._getList(this.state._params));
  }
  
  _handleResetFilter(e){
    e.preventDefault();
    const newState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      ...newState,
      _params:{
        ...defaultParams
      }
    },()=>this._getList(this.state._params));
  }
    
  render(){
    return(
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Collection List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel 
                  {...this.state._params} 
                  onHandleChange={this._handleParamsChange}
                  onHandleChangeAndSubmit={this._handleParamsChangeAndSubmit}
                  onHandleSearch={this._handleRefresh}
                  isOpen={this.state._filterOpen}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section will display our product's collection.
                </CardText>
                <div className="table-responsive">
                  <PaginationSummaries
                    from={this.props.masterCollection.list.from}
                    to={this.props.masterCollection.list.to}
                    total={this.props.masterCollection.list.total}
                  />
                  <Tbl>
                    <TblHead
                      renderChildren={()=>(
                        <tr>
                          <Th>No.</Th>
                          <Th>
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                              <p style={{marginRight: 10, marginBottom: 0}}>
                                Name
                                {
                                  this.state.collectionType !== null?
                                  <span style={{display: 'block', fontSize: '.5rem'}}>
                                    {this.state.collectionType === 'product_variants'? 'variants': this.state.collectionType}
                                  </span>
                                  : null
                                }
                              </p>
                              <CollectionTypeButton
                                value={this.state.collectionType}
                                onClick={async value => {
                                  let body = {}
                                  if(this.state.collectionType !== value){
                                    if(["PARENT", "HERO", "LOOK"].includes(value)){
                                      body.collection_type = null;
                                      body.ui_template = value;
                                    } else{
                                      body.collection_type = value;
                                      body.ui_template = null;
                                    }
                                  } else{
                                    body = {
                                      collection_type: null,
                                      ui_template: null,
                                    }
                                  }
                                  await this.setState({
                                    _params: {
                                      ...this.state._params,
                                      ...body
                                    },
                                    collectionType: this.state.collectionType !== value? value: null
                                  })
                                  this._getList(this.state._params)
                                }}
                              />
                            </div>
                          </Th>
                          <Th>Active</Th>
                          <Th>Featured</Th>
                          <Th>Updated</Th>
                          <Th>Action</Th>
                        </tr>
                      )}
                    />
                    <TblBody
                      isLoad={this.props.masterCollection.isFetch}
                      hasRow={this.props.masterCollection.list.status_code===200&&this.props.masterCollection.list.data.length>0}
                      columnCount={6}
                    >
                    { this._onRenderRowItem() }
                    </TblBody>
                  </Tbl>
                </div>
                { this._onRenderPagination() }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps= ({ masterCollection, auth: { isFetch, roles, isLogged, id, email } }) => {
	return {
    guardData: { isFetch, roles, isLogged, id, email },
		masterCollection
	}
};

const mapDispatchToProps = (dispatch) => {
	return{
		getList:(query) => dispatch(getCollectionList(query))
	}

};

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(privateView(CollectionIndex, ['supervisor', 'sale_supervisor', 'inventory_admin']));